import { render } from "./StudentPlaceGame.vue?vue&type=template&id=f9339a46"
import script from "./StudentPlaceGame.vue?vue&type=script&lang=js"
export * from "./StudentPlaceGame.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__